/**
 * Created by sagil on 06/10/2016.
 */

import {Pipe, PipeTransform} from "@angular/core";
import {KendoDatetimeLocaleService} from "../services/kendo.datetime.service";

/**
 * **********************************************************************
 * Pipe that handles formatting of dates.
 *
 * Written by: Sagi Levi
 * **********************************************************************
 */
@Pipe({
	name: 'cpDayName',
	pure: true
})
export class DayNamePipe implements PipeTransform {

	constructor(private datetimeFormatService:KendoDatetimeLocaleService) {
	}

	transform(query: Date):any {
		return this.datetimeFormatService.date(query, "DayName");
	}
}
